export const apiEndpoints = {
  stats: "https://defi-stats.komodo.earth/api/v3/stats_xyz/atomicdexio",
  coins: "https://raw.githubusercontent.com/KomodoPlatform/coins/master/coins",
};
